import { Reference } from 'app/model/Reference';

/**
 * Элемент справочника улиц.
 */
export class StreetReference extends Reference {
    /**
     * id (код) типа улицы (см. /street-types).
     */
    type: string;

    /**
     * Список почтовых индексов связанных с улицей.
     */
    postcodes: Set<string>;

    constructor(
        id: string,
        name: string,
        type: string,
        postcodes: Set<string>,
    ) {
        super(id, name);
        this.type = type;
        this.postcodes = postcodes;
    }

    static deserialize(data: any) {
        return new StreetReference(
            data.id,
            data.name,
            data.type,
            new Set(data.postcodes),
        );
    }
}
